import React from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { Zap, Shield, Smartphone, Cloud, Users, BarChart3 } from 'lucide-react'
import WaterfallFadeIn from './WaterfallFadeIn'

const FeaturesSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const features = [
    {
      icon: Zap,
      title: 'Lightning Fast Performance',
      description: 'Advanced processing technology ensures real-time imaging with minimal latency.',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: Shield,
      title: 'Enterprise Security',
      description: 'HIPAA-compliant systems with end-to-end encryption and secure data transmission.',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: Smartphone,
      title: 'Mobile Integration',
      description: 'Seamless connectivity with mobile devices for remote monitoring and consultation.',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: Cloud,
      title: 'Cloud-Based Solutions',
      description: 'Secure cloud storage and sharing capabilities for enhanced collaboration.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: Users,
      title: 'Multi-User Support',
      description: 'Simultaneous access for multiple healthcare professionals and specialists.',
      color: 'from-red-500 to-pink-500'
    },
    {
      icon: BarChart3,
      title: 'Advanced Analytics',
      description: 'AI-powered analysis tools for improved diagnostic accuracy and reporting.',
      color: 'from-indigo-500 to-purple-500'
    },
  ]

  return null
  // return (
  //   <section className="section-padding bg-gray-200">
  //     <div className="container-custom">
  //       <motion.div
  //         ref={ref}
  //         initial={{ opacity: 0, y: 50 }}
  //         animate={inView ? { opacity: 1, y: 0 } : {}}
  //         transition={{ duration: 0.8 }}
  //         className="text-center mb-16"
  //       >
  //         <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-6">
  //           <span className="w-2 h-2 bg-primary-500 rounded-full mr-2"></span>
  //           Why Choose Us
  //         </div>
  //         <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
  //           Cutting-Edge Technology Features
  //         </h2>
  //         <p className="text-xl text-gray-600 max-w-3xl mx-auto">
  //           Our ultrasound systems combine advanced technology with user-friendly design 
  //           to deliver exceptional diagnostic capabilities.
  //         </p>
  //       </motion.div>

  //       <WaterfallFadeIn
  //         baseDelay={0.1}
  //         duration={0.8}
  //         direction="up"
  //         distance={50}
  //         className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
  //       >
  //         {features.map((feature, index) => (
  //           <div key={index} className="group">
  //             <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
  //               <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
  //               <feature.icon className="w-8 h-8 text-white" />
  //               </div>
                
  //               <h3 className="text-xl font-bold text-gray-900 mb-4">
  //                 {feature.title}
  //               </h3>
                
  //               <p className="text-gray-600">
  //                 {feature.description}
  //               </p>
  //             </div>
  //           </div>
  //         ))}
  //       </WaterfallFadeIn>
  //     </div>
  //   </section>
  // )
}

export default FeaturesSection 